import utils from './drawUtils'

const controlPointDist = 80

// Triangle dimensions
const Tw = 15
const Th = 20

// Handle parameters
const Hradius = 10

export default class {
  constructor (id, A, B, thickness, color) {
    this.id = id
    this.A = A
    this.B = B
    this.thickness = thickness
    this.color = color
  }

  draw (ctx, state) {
    const dy = this.A.pos[1] - this.B.pos[1]

    // center points of A & B
    const Acx = this.A.pos[0] + this.A.size[0] / 2
    const Acy = this.A.pos[1] + this.A.size[1] / 2
    const Bcx = this.B.pos[0] + this.B.size[0] / 2
    const Bcy = this.B.pos[1] + this.B.size[1] / 2

    // start/end points for the spline
    let Ax
    let Ay
    let Bx
    let By
    let Tx
    let Ty
    if ((this.A.pos[1] - this.B.pos[1]) > 0) {
      Ax = this.A.pos[0] + this.A.size[0] / 2
      Ay = this.A.pos[1]
      Bx = this.B.pos[0] + this.B.size[0] / 2
      By = this.B.pos[1] + this.B.size[1] + Th

      Tx = this.B.pos[0] + this.B.size[0] / 2
      Ty = this.B.pos[1] + this.B.size[1]
    } else {
      Ax = this.A.pos[0] + this.A.size[0] / 2
      Ay = this.A.pos[1] + this.A.size[1] + Th
      Bx = this.B.pos[0] + this.B.size[0] / 2
      By = this.B.pos[1]

      Tx = this.A.pos[0] + this.A.size[0] / 2
      Ty = this.A.pos[1] + this.A.size[1]
    }

    const path = new Path2D()

    // start at A's center
    path.moveTo(Acx, Acy)

    // start spline at A
    path.lineTo(Ax, Ay)

    path.bezierCurveTo(
      Ax, (dy < 0) ? (Ay + controlPointDist) : (Ay - controlPointDist),
      Bx, (dy < 0) ? (By - controlPointDist) : (By + controlPointDist),
      Bx, By
    )

    path.lineTo(Bcx, Bcy)

    ctx.lineWidth = this.thickness
    ctx.strokeStyle = this.color
    ctx.stroke(path)

    // Draw arrow pointing upwards
    ctx.beginPath()
    ctx.moveTo(Tx, Ty)
    ctx.lineTo(Tx + this.thickness / 2, Ty)
    ctx.lineTo(Tx + (Tw + this.thickness) / 2, Ty + Th)
    ctx.lineTo(Tx - (Tw + this.thickness) / 2, Ty + Th)
    ctx.lineTo(Tx - this.thickness / 2, Ty)
    ctx.closePath()

    ctx.fillStyle = this.color
    ctx.fill()

    // draw link handle at center of spline
    const Hx = (Ax + Bx) / 2
    const Hy = (Ay + By) / 2
    utils.drawCircle(ctx, Hx, Hy, Hradius, '#808080', 'black', 2)
  }

  isIn (x, y) {
    let Ax
    let Ay
    let Bx
    let By
    if ((this.A.pos[1] - this.B.pos[1]) > 0) {
      Ax = this.A.pos[0] + this.A.size[0] / 2
      Ay = this.A.pos[1]
      Bx = this.B.pos[0] + this.B.size[0] / 2
      By = this.B.pos[1] + this.B.size[1] + Th
    } else {
      Ax = this.A.pos[0] + this.A.size[0] / 2
      Ay = this.A.pos[1] + this.A.size[1] + Th
      Bx = this.B.pos[0] + this.B.size[0] / 2
      By = this.B.pos[1]
    }

    const Hx = (Ax + Bx) / 2
    const Hy = (Ay + By) / 2

    const distSq = (x - Hx) * (x - Hx) + (y - Hy) * (y - Hy)
    return distSq < Hradius * Hradius
  }
}
